export default "__VITE_ASSET__u5WPRRS5zEL$Fqpf5qVGlw__"